import { NumberField } from './NumberField'
import { withNumberField } from './withNumberField'

const ConnectedNumberField = withNumberField(NumberField)

export { ConnectedNumberField as NumberField }
